'use strict';

window.CFC = window.CFC || {};

window.CFC.Forms = (function($) {
  function init() { 
    setInnerLabelHandlers();
  }
  
  /**
   * An "inner label" is a label that appears inside the input.  The surrounding field container is toggled
   * between "field_label--inside" and "field_label--outside".  If the field is focused or contains a value, the label
   * is set to outside.
   */
  function setInnerLabelHandlers() {
    const $innerLabels = $('.field_label--inside').closest('.dialog__field');
    
    $innerLabels.find('input')
      .off('change', handleInnerLabelUpdate)
      .on('change', handleInnerLabelUpdate)
      .off('focus', handleInnerLabelUpdate)
      .on('focus', handleInnerLabelUpdate)
      .off('blur', handleInnerLabelUpdate)
      .on('blur', handleInnerLabelUpdate)
      .each(handleInnerLabelUpdate);
  }
  
  function handleInnerLabelUpdate() {
    const field = this.closest('.dialog__field');
    const label = field.querySelector('.field_label--inside, .field_label--outside');
    const hasValue = !!this.value;
    const hasFocus = (document.activeElement === this);
    const labelIsInner = (!hasValue && !hasFocus);
    const className = `field_label--${ labelIsInner ? 'inside' : 'outside' }`; 
    const classList = label.classList;
    
    classList.remove('field_label--inside');
    classList.remove('field_label--outside');
    classList.add(className);
  }
    
  $(init);
  
  return { setInnerLabelHandlers };
})(jQuery);